export default {
  shopNow: "Shop Now",
  comingSoon: "Coming Soon",
  megaOffer: "MEGA OFFER",
  home: { title: "hoem title 000" },
  colorSelected: "Color selected:",
  discountBar: {
    1: { discount: "49%  OFF", title: "for COffee SEEKERS!" },
    2: { discount: "55% OFF", title: "for milk lover" },
    3: { discount: "70% off", title: "for add on finest" },
  },

  common: {
    scroll: "Scroll to see<br/>the offer",
    buyNow: "BUY<br/>NOW",
    learnMore: "Terms and Conditions",
    offer: "BUY NOW",
    ingredient: "ingredient",
    step: "STEP",
    bestSeller: "BEST SELLER",
    addToCart: "ADD TO CART",
  },
  toteBag: {
    title: "Ash Limited edition tote bag",
    description:
      "Nespresso joins Italian fashion shoe brand ASH to launch the limited ASH Tote Bag.",
  },
  giftCups: {
    title: "Barista Mixologist Glasses Small (300ml)",
    description:
      "End your day on a high note with the Barista Mixologist Glasses. As day turns into night, the Barista Mixologist Glasses designed by Federico Peri come out to embrace the moment. With a see-through pane to gaze upon your cold coffee drinks and vertical stripes that dance around the glass, you can experiment between the lines, or outside the lines.<br><br>Capacity<br><br>300ml<br>8,38 cm, Ø 8,25 cm",
  },
  miniCaps: {
    title: "Singles' Day 5-Sleeve Coffee Assortment",
    description: `<ul class="disc">
      <li>Festive Collection Espresso X 10</li>
      <li>Festive Collection Flavoured Cinnamon And Candied Tamarind X 10</li>
      <li>Festive Collection Flavoured Sweet Almond And Hibiscus X 10</li>
      <li>Nocciola x 10</li>
      <li>Caramello x 10</li>
    </ul>`,
  },
  vlCaps: {
    title: "Singles' Day 3-Sleeve Coffee Assortment",
    description: `<ul class="disc">
      <li>Festive Collection Espresso X 10</li>
      <li>Festive Collection Flavoured Cinnamon And Candied Tamarind X 10</li>
      <li>Festive Collection Flavoured Sweet Almond And Hibiscus X 10</li>
    </ul>`,
  },
  counter: {
    title: {
      brand: "NESPRESSO",
      event: "11.11 SINGLES' DAY",
      date: "5 - 12 NOV 2025",
    },
    days: "Days",
    hours: "Hours",
    minutes: "Minutes",
    seconds: "Seconds",
  },

  landingBanner: {
    vertuoPopOffer: "Vertuo pop<br /> Offer",
    miniOffer: "Essenza Mini<br /> Offer",
    back: "< Back",
    exclusiveBadge: "<span>Exclusive</span> for Single Day",
    exclusiveBadgeTitle: "EXCLUSIVE",
    exclusiveBadgeSubtitle: "for Singles' Day",
    productTitle: "ESSENZA MINI COFFEE MACHINE BUNDLE OFFER",
    productTitleV: "VERTUO POP COFFEE MACHINE BUNDLE OFFER",
    productDescription:
      "Complete coffee experience with machine, accessories, and premium capsules for the perfect brew.",
    productPrice: "HK$888",
    originalPrice: "HK$1,692",
    discount: "47% OFF",
    coffeeCup: "MIXOLOGIST GLASSES",
    ashToteBag: "ASH LIMITED<br />EDITION TOTE BAG",
    coffeeAssortment: "Singles' Day <br/>5-Sleeve Coffee Assortment",
    vlCapsAssortment: "Singles' Day <br/>3-Sleeve Coffee Assortment",
  },

  products: {
    title: "Discover Our Collection",
    subtitle: "Find the perfect coffee machine for your lifestyle",
  },

  productSection: {
    colorSelected: "Color selected:",
    addToCart: "ADD TO CART",
    off: "OFF",
    title: "Accessory Offer for milk lover",
  },

  mega: {
    title: "Mega offer",
    desc: "Mega Singles’ Day Coffee Bundle – Pay Less, Get More!<br>One bundle, endless coffee joy – plus FREE Festive Gifts!",
    tab_mini: "ESSENZA MINI",
    tab_verto: "Vertuo Pop",
    mini: [
      {
        title: "ESSENZA Mini Mega Offer",
        remarks: "(Special price only for matt black version)",
        specf: [
          "Essenza Mini Coffee Machine - Matt Black",
          "Singles' Day 5-Sleeve Coffee Assortment",
          "World Explorations 10-Sleeve Assortment",
          "Lisbon Coffee",
          "VIEW Versilo Transparent Coffee Capsule Dispenser- Original",
          "Barista Mixologist Glasses Small (300ml)",
          "ASH Limited Edition Tote Bag (Brown)",
          "Festive Blanket",
          "Barista Mixologist Stemmed Glass",
          "Reversible tote Bag",
        ],
        price: "HK$1,776",
        originalPrice: "HK$3,749",
        discount: "53% OFF",
        colorName: "Matt Black",
        colorCode: "#000000",
        SKU: "162225",
        img: "/assets/images/2025/mega_mini_black.png",
      },
    ],
    verto: [
      {
        title: "Vertuo Pop Mega Offer",
        specf: [
          "Vertuo Pop Coffee Machine - Blue",
          "Singles' Day 3-Sleeve Coffee Assortment",
          "Vertuo Barista Creation 6 Sleeve Coffee Assortment",
          "Display Collection Vertical Dispenser - Vertuo",
          "Barista Mixologist Glasses Small (300ml)",
          "ASH Limited Edition Tote Bag (Red)",
          "Festive Blanket",
          "Barista Mixologist Stemmed Glass",
          "Reversible tote Bag",
        ],
        price: "HK$1,748",
        originalPrice: "HK$3,716",
        discount: "53% OFF",
        colorName: "White",
        colorCode: "#FFFFFF",
        SKU: "162226",
        img: "/assets/images/2025/mega_vertuo_white.png",
      },
    ],
  },

  banner: {
    top1: "+$1 REDEEM",
    top2: "30 CAPSULES & TRAVEL MUG",
    title: "<b>Vertuo Pop</b><br/>Coffee Machine",
    desc: "One of Nespresso's most compact machines, perfect for space savvy coffee lovers looking for a splash of color.",
    price: "HKD 1,088",
    colorSelected: "Color selected:",
    scrollToSee: "Scroll to see <br/>the offer",
    addOn: "ENJOY 30 CUPS OF COFFEE FOR JUST $1",
    only: "200 SETS ONLY",
    machine: {
      essenzaMini: [
        {
          price: "HK$999 ",
          originalPrice: "HK$$1,981 ",
          discount: "49% OFF",
          remarks: "(Special price only for Matt Black version)",
          sku: "161531",
          desc: "Essenza Mini - Matt Black",
          colorName: "Matt Black",
          colorCode: "#000000",
          imgPath: "/assets/images/2025/essenza_mini_mat_black.png",
          imgGift: "/assets/images/2025/essenza_mini_gift.png",
          imgPathPreview: "/assets/images/2025/mini_selected_black.png",
          specf: [
            "Essenza Mini Coffee Machine",
            "Singles' Day 5-Sleeve Coffee Assortment",
            "Barista Mixologist Glasses Small (300ml)",
            "ASH Limited Edition Tote Bag (Brown)",
          ],
        },
        {
          price: "HK$1,088 ",
          originalPrice: "HK$$1,981 ",
          discount: "45% OFF",
          remarks: "",
          sku: "161564",
          desc: "Essenza Mini - Green",
          colorName: "Green",
          colorCode: "#CFE500",
          imgPath: "/assets/images/2025/essenza_mini_green.png",
          imgGift: "/assets/images/2025/essenza_mini_gift.png",
          imgPathPreview: "/assets/images/2025/mini_selected_green.png",
          specf: [
            "Essenza Mini Coffee Machine",
            "Singles' Day 5-Sleeve Coffee Assortment",
            "Barista Mixologist Glasses Small (300ml)",
            "ASH Limited Edition Tote Bag (Brown)",
          ],
        },
        {
          price: "HK$1,088 ",
          originalPrice: "HK$$1,981 ",
          discount: "45% OFF",
          remarks: "",
          sku: "161565",
          desc: "Essenza Mini - Red",
          colorName: "Red",
          colorCode: "#FF0000",
          imgPath: "/assets/images/2025/essenza_mini_red.png",
          imgGift: "/assets/images/2025/essenza_mini_gift.png",
          imgPathPreview: "/assets/images/2025/mini_selected_red.png",
          specf: [
            "Essenza Mini Coffee Machine",
            "Singles' Day 5-Sleeve Coffee Assortment",
            "Barista Mixologist Glasses Small (300ml)",
            "ASH Limited Edition Tote Bag (Brown)",
          ],
        },
        {
          price: "HK$1,088 ",
          originalPrice: "HK$$1,981 ",
          discount: "45% OFF",
          remarks: "",
          sku: "161563",
          desc: "Essenza Mini - Grey",
          colorName: "Grey",
          colorCode: "#757575",
          imgPath: "/assets/images/2025/essenza_mini_grey.png",
          imgGift: "/assets/images/2025/essenza_mini_gift.png",
          imgPathPreview: "/assets/images/2025/mini_selected_grey.png",
          specf: [
            "Essenza Mini Coffee Machine",
            "Singles' Day 5-Sleeve Coffee Assortment",
            "Barista Mixologist Glasses Small (300ml)",
            "ASH Limited Edition Tote Bag (Brown)",
          ],
        },

        {
          price: "HK$1,088 ",
          originalPrice: "HK$$1,981 ",
          discount: "45% OFF",
          remarks: "",
          sku: "161562",
          desc: "Essenza Mini - White",
          colorName: "White",
          colorCode: "#FFFFFF",
          imgPath: "/assets/images/2025/essenza_mini_white.png",
          imgGift: "/assets/images/2025/essenza_mini_gift.png",
          imgPathPreview: "/assets/images/2025/mini_selected_white.png",

          specf: [
            "Essenza Mini Coffee Machine",
            "Singles' Day 5-Sleeve Coffee Assortment",
            "Barista Mixologist Glasses Small (300ml)",
            "ASH Limited Edition Tote Bag (Brown)",
          ],
        },

        {
          price: "HK$1,088 ",
          originalPrice: "HK$$1,981 ",
          discount: "45% OFF",
          remarks: "",
          sku: "161561",
          desc: "Essenza Mini - Black",
          colorName: "Black",
          colorCode: "#000000",
          imgPath: "/assets/images/2025/essenza_mini_black.png",
          imgGift: "/assets/images/2025/essenza_mini_gift.png",
          imgPathPreview: "/assets/images/2025/mini_selected_mat_black.png",
          specf: [
            "Essenza Mini Coffee Machine",
            "Singles' Day 5-Sleeve Coffee Assortment",
            "Barista Mixologist Glasses Small (300ml)",
            "ASH Limited Edition Tote Bag (Brown)",
          ],
        },
      ],
      vertuoPop: [
        {
          price: "HK$999",
          originalPrice: "HK$1,976",
          discount: "49% OFF",
          remarks: "",
          sku: "161566",
          desc: "Vertuo Pop - Red",
          colorName: "Red",
          colorCode: "#FF0000",
          imgPath: "/assets/images/2025/vertuo_pop_red.png",
          imgGift: "/assets/images/2025/vertuo_pop_gift.png",
          imgPathPreview: "/assets/images/2025/vertuo_selected_red.png",
          specf: [
            "Vertuo Pop Coffee Machine",
            "Singles' Day 3-Sleeve Coffee Assortment",
            "Barista Mixologist Glasses Small (300ml)",
            "ASH Limited Edition Tote Bag (Red)",
          ],
        },
        {
          price: "HK$999",
          originalPrice: "HK$1,976",
          discount: "49% OFF",
          remarks: "",
          sku: "161567",
          desc: "Vertuo Pop - Black",
          colorName: "Black",
          colorCode: "#595959",
          imgPath: "/assets/images/2025/vertuo_pop_black.png",
          imgGift: "/assets/images/2025/vertuo_pop_gift.png",
          imgPathPreview: "/assets/images/2025/vertuo_selected_black.png",
          specf: [
            "Vertuo Pop Coffee Machine",
            "Singles' Day 3-Sleeve Coffee Assortment",
            "Barista Mixologist Glasses Small (300ml)",
            "ASH Limited Edition Tote Bag (Red)",
          ],
        },
        {
          price: "HK$999",
          originalPrice: "HK$1,976",
          discount: "49% OFF",
          remarks: "",
          sku: "161568",
          desc: "Vertuo Pop - Blue",
          colorName: "Blue",
          colorCode: "#73ACF2",
          imgPath: "/assets/images/2025/vertuo_pop_blue.png",
          imgGift: "/assets/images/2025/vertuo_pop_gift.png",
          imgPathPreview: "/assets/images/2025/vertuo_selected_blue.png",
          specf: [
            "Vertuo Pop Coffee Machine",
            "Singles' Day 3-Sleeve Coffee Assortment",
            "Barista Mixologist Glasses Small (300ml)",
            "ASH Limited Edition Tote Bag (Red)",
          ],
        },
        {
          price: "HK$999",
          originalPrice: "HK$1,976",
          discount: "49% OFF",
          remarks: "",
          sku: "161569",
          desc: "Vertuo Pop - White",
          colorName: "White",
          colorCode: "#FFFFFF",
          imgPath: "/assets/images/2025/vertuo_pop_white.png",
          imgGift: "/assets/images/2025/vertuo_pop_gift.png",
          imgPathPreview: "/assets/images/2025/vertuo_selected_white.png",
          specf: [
            "Vertuo Pop Coffee Machine",
            "Singles' Day 3-Sleeve Coffee Assortment",
            "Barista Mixologist Glasses Small (300ml)",
            "ASH Limited Edition Tote Bag (Red)",
          ],
        },
        {
          price: "HK$999",
          originalPrice: "HK$1,976",
          discount: "49% OFF",
          remarks: "",
          sku: "161570",
          desc: "Vertuo Pop - Yellow",
          colorName: "Yellow",
          colorCode: "#F8AA2D",
          imgPath: "/assets/images/2025/vertuo_pop_yellow.png",
          imgGift: "/assets/images/2025/vertuo_pop_gift.png",
          imgPathPreview: "/assets/images/2025/vertuo_selected_yellow.png",
          specf: [
            "Vertuo Pop Coffee Machine",
            "Singles' Day 3-Sleeve Coffee Assortment",
            "Barista Mixologist Glasses Small (300ml)",
            "ASH Limited Edition Tote Bag (Red)",
          ],
        },
        {
          price: "HK$999",
          originalPrice: "HK$1,976",
          discount: "49% OFF",
          remarks: "",
          sku: "161571",
          desc: "Vertuo Pop - Aqua",
          colorName: "Aqua",
          colorCode: "#4CD8C5",
          imgPath: "/assets/images/2025/vertuo_pop_aqua.png",
          imgGift: "/assets/images/2025/vertuo_pop_gift.png",
          imgPathPreview: "/assets/images/2025/vertuo_selected_aqua.png",
          specf: [
            "Vertuo Pop Coffee Machine",
            "Singles' Day 3-Sleeve Coffee Assortment",
            "Barista Mixologist Glasses Small (300ml)",
            "ASH Limited Edition Tote Bag (Red)",
          ],
        },
        {
          price: "HK$999",
          originalPrice: "HK$1,976",
          discount: "49% OFF",
          remarks: "",
          sku: "161572",
          desc: "Vertuo Pop - Lilac",
          colorName: "Lilac",
          colorCode: "#D6BBED",
          imgPath: "/assets/images/2025/vertuo_pop_liac.png",
          imgGift: "/assets/images/2025/vertuo_pop_gift.png",
          imgPathPreview: "/assets/images/2025/vertuo_selected_liac.png",
          specf: [
            "Vertuo Pop Coffee Machine",
            "Singles' Day 3-Sleeve Coffee Assortment",
            "Barista Mixologist Glasses Small (300ml)",
            "ASH Limited Edition Tote Bag (Red)",
          ],
        },
      ],
    },
  },

  productSectionData: [
    [
      {
        name: "Aeroccino3 Black Milk Frother",
        desc: [
          "Aeroccino3 Black Milk Frother",
          "VIEW Spoon (Small) - Set of 6",
          "Barista towels, set of 2",
        ],
        price: "499",
        orgPrice: "1130",
        discount: "55% OFF",
        img: "/assets/images/2025/milk_lover_black.png",
        colorName: "Black",
        colorCode: "#000000",
        sku: "3594-SG-BK",
      },
      {
        name: "Aeroccino3 Red Milk Frother",
        desc: [
          "Aeroccino3 Red Milk Frother",
          "VIEW Spoon (Small) - Set of 6",
          "Barista towels, set of 2",
        ],
        price: "499",
        orgPrice: "1130",
        discount: "55% OFF",
        img: "/assets/images/2025/milk_lover_red.png",
        colorName: "Red",
        colorCode: "#BA3030",
        sku: "3594-SG-RE",
      },
      {
        name: "Aeroccino3 White Milk Frother",
        desc: [
          "Aeroccino3 White Milk Frother",
          "VIEW Spoon (Small) - Set of 6",
          "Barista towels, set of 2",
        ],
        price: "499",
        orgPrice: "1130",
        discount: "55% OFF",
        img: "/assets/images/2025/milk_lover_white.png",
        colorName: "Pure White",
        colorCode: "#FFFFFF",
        sku: "3594-SG-WH",
      },
    ],
  ],

  special: {
    title: "ONLINE EXCLUSIVE<br>LIMITED 200 Sets",
    desc: "<b>+$1 Redeem</b> ",
    detail: ` 
    <b>1. Best Seller Coffee Capsules x30</b>
    <ul>
    <li>Barista Creations Roasted Hazelnut x10</li>
    <li>Espresso Altissio x10</li>
    <li>Long Black Odacio x10</li>
  </ul>
  <b>2. Travel Mug x 1</b>`,
    price: "HKD 1",
    priceTotal: "HKD433",
  },

  cups: {
    title: "One Button<br><b>6 cup sizes Available</b>",
    desc: "The small yet powerful machine offers great versatility with six cup sizes available. No matter the size, enjoy a one-of-a-kind taste experience. Get ready to be spoiled with choices! ",

    cups: [
      { name: "Ristretto", cap: "25ml", img: "vl_ristretto.png" },
      { name: "Espresso", cap: "40ml", img: "vl_espresso.png" },
      { name: "Double Espresso", cap: "80ml", img: "vl_double-espresso.png" },
      { name: "Gran Lungo", cap: "150ml", img: "vl_gran-lungo.png" },
      { name: "Mug", cap: "230ml", img: "vl_mug.png" },
      { name: "Alto", cap: "355ml", img: "vl_alto.png" },
    ],
  },

  includes: {
    title: "<b>What’s <b>included?</b>",
    desc: "Variety subject to change bases on stock availability",

    details: [
      {
        tag: "Espresso | 40ml",
        name: "Altissio",
        desc: "Full Bodied & Creamy",
        bgColor: "#6C4A99",
        img: "capAltissio.png",
        best: true,
        content: {
          collpaseTitle: "unforgettable <b>Recipe</b>",
          img: "altissio_bg.jpg",
          title: "TIRAMISU COFFEE",
          icons: [
            { icon: "clock", txt: "8 min" },
            { icon: "level", txt: "Medium" },
          ],
          ingredient: [
            {
              name: "Chocolate Sauce",
              cap: "2 Teaspoon",
              img: "altissio_choco.png",
            },
            {
              name: "Mascarpone",
              cap: "2 Teaspoon",
              img: "altissio_cheese.png",
            },
            {
              name: "Milk",
              cap: "10 cl",
              img: "altissio_milk.png",
            },
            {
              name: "Speculoos",
              cap: "3 Unit",
              img: "altissio_caramel.png",
            },
          ],
          steps: [
            "Add melted chocolate in the recipe glass",
            "Add mascarpone",
            "Add milk foam from the Aeroccino",
            "Finally pour the Nespresso Intenso",
            "Sprinkle with speculoos",
          ],
        },
      },

      {
        tag: "Barista Creations | 80 ml",
        name: "Roasted HazelnUt",
        desc: "Rich & Nutty",
        bgColor: "#873427",
        img: "capRoasted.png",
        best: true,
        content: {
          collpaseTitle: "unforgettable <b>Recipe</b>",
          img: "roastred_bg.jpg",
          title: "ROASTED HAZELNUT HONEY & OAT REVERSO",
          icons: [
            { icon: "clock", txt: "3 min" },
            { icon: "level", txt: "Easy" },
          ],
          ingredient: [
            { name: "Roasted Hazelnut", cap: "230 ml", img: "roasted_cap.png" },
            {
              name: "Oat Plant-Based<br/>Beverage",
              cap: "50 ml",
              img: "roasted_beverage.png",
            },
            {
              name: "Honey",
              cap: "15 g",
              img: "roasted_honey.png",
            },
            {
              name: "Crushed Hazelnuts",
              cap: "5 g",
              img: "roasted_nut.png",
            },
          ],
          steps: [
            "Place crushed hazelnuts in a shallow dish; spread the honey on the edge of the mug. Dip rim of mug into hazelnut, shaking off excess.",
            "On the bottom of the Vertuo mug pour honey, then pour the cold plant-based oat beverage.",
            "Brew 230 ml of Roasted Hazelnut directly on the mug.",
            "Enjoy!",
          ],
        },
      },

      {
        tag: "Signature | 230ml",
        name: "ODACIO",
        desc: "Bold & Lively",
        bgColor: "#007194",
        img: "capOdacio.png",

        content: {
          collpaseTitle: "unforgettable <b>Recipe</b>",
          img: "odacio_bg.jpg",
          title: "ICED COFFEE",
          icons: [
            { icon: "clock", txt: "5 min" },
            { icon: "level", txt: "Medium" },
          ],
          ingredient: [
            {
              name: "Ice",
              cap: "2 Units",
              img: "odacio_ice.png",
            },
            {
              name: "ODACIO coffee",
              cap: "1 Capsule",
              img: "odacio_cap.png",
            },
            {
              name: "12 oz. GLASS",
              cap: "1 Glass",
              img: "odacio_glass.png",
            },
          ],
          steps: [
            "Fill recipe glass with ice.",
            "Brew coffee into metal pitcher.",
            "Pour coffee over ice to fill glass.",
            "Stir to chill. Enjoy!",
          ],
        },
      },

      {
        tag: "Max. capacity 380ml",
        name: "Touch Nomad Travel Mug",
        iconClass: "mug",
        bgColor: "#898989",
        img: "special-mug.png",
      },
    ],
  },

  machine: {
    title:
      "Perfect for first homes, office spaces or university. Begin your coffee journey today with <b>Vertuo Pop</b>!",
    video: "",
  },

  howToUse: {
    title: "how to <b>use</b>",
    steps: [
      {
        txt: "insert capsule",
        img: "howTo1.jpg",
      },
      {
        txt: "press the<br/>button",
        img: "howTo2.jpg",
      },
      {
        txt: "enjoy!",
        img: "howTo3.jpg",
      },
    ],
  },

  feature: {
    title: "our <b>Features</b>",

    details: [
      {
        icon: "tech",
        txt: "CENTRIFUSION<sup>TM</sup><br/>TECHNOLOGY",
      },
      {
        icon: "simple_touch",
        txt: "AUTOMATIC brew size",
      },

      {
        icon: "automatic_brew_size",
        txt: "SIMPLE, ONE-TOUCH BREWING",
      },

      {
        icon: "connectivity",
        txt: "CONNECTIVITY",
      },
    ],
  },

  suggestion: {
    title: "you may <b>like to find</b>",
    details: [
      {
        img: "like1.png",
        txt: "Difference Between Vertuo And Original",
        link: "https://www.nespresso.com/hk/en/choose-your-system",
      },
      {
        img: "like2.png",
        txt: "Vertuo Coffees",
        link: "https://www.nespresso.com/hk/en/order/capsules/vertuo",
      },
      {
        img: "like3.png",
        txt: "Explore Our Accessory",
        link: "https://www.nespresso.com/hk/en/order/accessories#types[0]=%E5%92%96%E5%95%A1%E7%B2%89%E5%9B%8A%E7%9B%9B%E6%94%BE%E5%99%A8",
      },
      {
        img: "like4.png",
        txt: "Order Coffee Capsules",
        link: "https://www.nespresso.com/hk/en/order/capsules/original",
      },
    ],
  },

  promote: {
    subtitle: "YEAR END PROMOTION",
    title: "Up to 20% OFF MACHINES",
    description: "except Essenza Mini and Ventuo Pop Coffee Machine",
    date: "3 Nov 2025 - 28 Dec 2025",
    cta: "DISCOVER OFFER",
    ctaLink: "https://www.nespresso.com/hk/en/order/machines/vertuo",
  },

  crossSelling: {
    title: "Recommend for You",
    subtitle:
      "Boost Your Coffee Experience – Buy More, Enjoy More!<br>Buy more coffee today and unlock our exclusive Coffee Booster offer.",
    addToCart: "ADD TO CART",
    products1: [
      {
        name: "Vertuo Barista Creation 6 Sleeve Coffee Assortment",
        sku: "155577",
        price: 550,
        addon: "BUY THIS TO ENJOY FESTIVE OFFER TIER 3",
        img: "/assets/images/2025/crosssell_vl_6_sleeve.png",
      },

      {
        name: "Festive Edition 6-sleeve coffee assortment",
        sku: "159540",
        price: 499,
        // addon: "BUY THIS TO ENJOY FESTIVE OFFER TIER 2",
        img: "/assets/images/2025/crosssell_vl_6_fest_sleeve.png",
      },

      {
        name: "Festive Edition 9-sleeve coffee assortment",
        sku: "159542",
        price: 871,
        // addon: "BUY THIS TO ENJOY FESTIVE OFFER TIER 2",
        img: "/assets/images/2025/crosssell_vl_9_fest_sleeve.png",
      },

      {
        name: "Double Espresso",
        sku: "7079.40",
        price: 113,
        addon: "",
        img: "/assets/images/2025/vl_cap_1.png",
      },
      {
        name: "Almond Hibsicus",
        sku: "7078.40",
        price: 113,
        addon: "",
        img: "/assets/images/2025/vl_cap_2.png",
      },
      {
        name: "Cinnamon Tamarind",
        sku: "7075.40",
        price: 113,
        addon: "",
        img: "/assets/images/2025/vl_cap_3.png",
      },
    ],
    products2: [
      {
        name: "World Explorations 10-Sleeve Assortment",
        sku: "128142",
        price: 500,
        addon: "BUY THIS TO ENJOY FESTIVE OFFER TIER 3",
        img: "/assets/images/2025/crosssell_org_10_sleeve.png",
      },
      {
        name: "Festive Collecton 5-Sleeve Coffee Assortment",
        sku: "159534",
        price: 308,
        // addon: "BUY THIS TO ENJOY FESTIVE OFFER TIER 2",
        img: "/assets/images/2025/crosssell_org_5_sleeve.png",
      },
      {
        name: "Festive Collecton 10-Sleeve Coffee Assortment",
        sku: "159536",
        price: 615,
        // addon: "BUY THIS TO ENJOY FESTIVE OFFER TIER 2",
        img: "/assets/images/2025/crosssell_org_10_fest_sleeve.png",
      },

      {
        name: "Espresso",
        sku: "7919.40",
        price: 78,
        addon: "",
        img: "/assets/images/2025/ol_cap_1.png",
      },
      {
        name: "Almond Hibsicus",
        sku: "7907.40",
        price: 78,
        addon: "",
        img: "/assets/images/2025/ol_cap_2.png",
      },
      {
        name: "Cinnamon Tamarind",
        sku: "7903.40",
        price: 78,
        addon: "",
        img: "/assets/images/2025/ol_cap_3.png",
      },
    ],
  },

  tab: {
    vertuo: {
      title: "VERTUO",
      subtitle: "The Full Range of Coffee Styles",
    },
    original: {
      title: "ORIGINAL",
      subtitle: "The Classic Espresso Experience",
    },
  },

  addonSection: {
    title: '70% off<br class="hide-desktop"/> for add on finest!',
    data: [
      {
        image: "/assets/images/addon-brown-sugar1.png",
        name: "Brown Sugar (60 Sticks x 4g)",
        price: "HK $19",
        originalPrice: "HK $66",
        discount: "71% OFF",
        sku: "3517",
      },
      {
        image: "/assets/images/addon-recycling-bin.png",
        name: "Recycling Bin",
        price: "HK $99",
        originalPrice: "HK $170",
        discount: "41% OFF",
        sku: "128557",
      },
      {
        image: "/assets/images/addon-collection.png",
        name: "VIEW Dispenser - Original",
        price: "HK $199",
        originalPrice: "HK $400",
        discount: "50% OFF",
        sku: "3586",
      },
      {
        image: "/assets/images/addon-coffee-capsule.png",
        name: "Display Dispenser - Vertuo",
        price: "HK $199",
        originalPrice: "HK $400",
        discount: "50% OFF",
        sku: "133246",
      },
      {
        image: "/assets/images/addon-pen.png",
        name: "Nespresso x Caran D'Ache Ballpen",
        price: "HK $199",
        originalPrice: "HK $300",
        discount: "33% OFF",
        sku: "133492",
      },
    ],
  },

  purchaseProcess: {
    title: "Purchase Process",
    description: "Follow these simple steps to complete your purchase",
  },

  recipe: {
    title:
      "Discover Festive Flavors with <span>Nespresso Limited Edition Coffee!</span>",
    description:
      "Celebrate the season with a cup of creativity! Our Festive Limited Edition Coffee is here to inspire your inner barista. Explore delightful recipes that turn every sip into a holiday moment.",
    viewAllButton: "DISCOVER RECIPES NOW",
    step: "Step",
    whatYouNeed: "What You Need",
    howToMake: "How to Make",
    popup: {
      servings: "Servings",
      prepTime: "Prep Time",
      ingredients: "Ingredients",
      instructions: "Instructions",
      tips: "Tips",
      close: "Close",
      minutes: "min",
      people: "people",
    },
    tabs: {
      essenzaMini: "ESSENZA MINI",
      vertuoPop: "Vertuo Pop",
    },
    products: {
      essenzaMini: [
        {
          name: "Minted Coffee Mule",
          imagePath: "/assets/images/2025/recipe_ol_product_1.png",
          detail: {
            tag: "",
            title: "Minted Coffee Mule",
            desc: "Refresh yourself with our zesty Ginger Lime Iced Coffee, featuring muddled lime and honey, topped with ginger beer and a splash of shaken coffee, garnished with fresh mint.",
            time: "5 mins",
            difficulty: "Easy",
            productImgPath: "/assets/images/2025/recipe_ol_product_1.png",
            howToMake: {
              steps: [
                "In a Nespresso Mixology glass put half of fresh non treated lime (30 g) cut in 6 pieces, add 10ml of Honey.",
                "Muddle it. Put 3 Ice cubes.",
                "Pour 60ml of Ginger beer. Stir gently while lifting the lime pieces to mix them in.",
                "In a Nespresso shaker, extract 40ml of Coffee and add 2 ice cubes, close the lid, shake vigorously.",
                "Pour the ice coffee it gently in the glass over the mixture. Add a nice branch of non-treated mint leave on top.",
                "Optional: 30ml of Vodka",
              ],
            },
            whatYouWant: {
              machine: {
                name: "Essenza Mini",
                desc: "Brew Espresso & Lungo With The Touch Of A Button",
                price: "HKD999",
                sku: "161531",
                imgPath: "/assets/images/essenza-mini-piano-black.png",
              },
              cap: {
                name: "Festive Collection Espresso",
                desc: "A deliciously round cup with cereal, ripe fruit and caramel notes, beautifully complemented by subtle woody undertones.",
                sku: "7919.40",
                imgPath: "/assets/images/2025/recipe_ol_cap1.png",
                props: [
                  { name: "Bitterness", value: 3 },
                  { name: "Acidity", value: 3 },
                  { name: "Roastiness", value: 3 },
                  { name: "Body", value: 3 },
                ],
              },
              recipt: [
                "1/2x Fresh non treated lime",
                "Honey: 10ml",
                "6x Nespresso ice cubes (30g)",
                "Ginger beer: 60ml",
              ],
            },
          },
        },
        {
          name: "Golden Hibiscus Latte",
          imagePath: "/assets/images/2025/recipe_ol_product_2.png",
          detail: {
            tag: "",
            title: "Golden Hibiscus Latte",
            desc: "Delight in our Sweet Almond & Hibiscus beverage, combining warm milk, honey, and aromatic edible flowers for a floral, cozy treat, with optional Dark Amarena cherries for an extra touch!",
            time: "5 mins",
            difficulty: "Easy",
            productImgPath: "/assets/images/2025/recipe_ol_product_2.png",
            howToMake: {
              steps: [
                "Heat up 100ml of milk 1.5% with the Barista Device (Hot milk mode).",
                "Into a Festive mug, put 10ml of honey and extract a 110ml OL Sweet Almond & Hibiscus (Double Click Recipe mode).",
                "Pour the hot milk into the mug.",
                "Sprinkle some dried edible Rose flowers or similars aromatic edible flowers.",
                "Optional: Add 2 Dark Amarena Cherries (on side)",
              ],
            },
            whatYouWant: {
              machine: {
                name: "Essenza Mini",
                desc: "Brew Espresso & Lungo With The Touch Of A Button",
                price: "HKD999",
                sku: "161531",
                imgPath: "/assets/images/essenza-mini-piano-black.png",
              },
              cap: {
                name: "Festive Collection Sweet Almond and Hibiscus OL	",
                desc: "A festive delight evoking almonds, hibiscus, red fruits and caramel in a sweet coffee base.",
                sku: "7907.40",
                imgPath: "/assets/images/2025/recipe_ol_cap2.png",
                props: [
                  { name: "Bitterness", value: 2 },
                  { name: "Acidity", value: 3 },
                  { name: "Roastiness", value: 2 },
                  { name: "Body", value: 2 },
                ],
              },
              recipt: [
                "Honey: 10ml",
                "1x OL Sweet Almond & Hibiscus",
                "Milk 1.5%: 100ml",
                "2x Amarena Cherries (Syrup)",
                "Edible Rose dried flowers: 1g",
              ],
            },
          },
        },
        {
          name: "Cinnamon Cloud Latte",
          imagePath: "/assets/images/2025/recipe_ol_product_3.png",
          detail: {
            tag: "",
            title: "Cinnamon Cloud Latte",
            desc: "Savor the festive Cinnamon & Candied Tamarind Coffee, featuring rich whipped cream, aromatic coffee, and a hint of cinnamon for a cozy treat!",
            time: "5 mins",
            difficulty: "Easy",
            productImgPath: "/assets/images/2025/recipe_ol_product_3.png",
            howToMake: {
              steps: [
                "Into a cream whipper siphon 0,5L, put 500ml of cream and one capsules* of whipper charger. Then shake it vigorously.",
                "Heat up 100ml of milk with the Barista Device (Hot milk mode).",
                "Into a Festive mug, put 10ml of date Syrup and extract a 110ml OL Cinnamon and Candied Tamarind Coffee.",
                "Pour the hot milk into the mug and add 60g of whipped cream on top.",
                "Add a cinnamon stick into the cream and sprinkle some cinnamon Powder.",
                "Optional: Infuse a bag of chai tea in 70 ml of hot water, cool it down, and add it to the siphon with the cream.",
              ],
            },
            whatYouWant: {
              machine: {
                name: "Essenza Mini",
                desc: "Brew Espresso & Lungo With The Touch Of A Button",
                price: "HKD999",
                sku: "161531",
                imgPath: "/assets/images/essenza-mini-piano-black.png",
              },
              cap: {
                name: "Festive Collection Cinnamon and Candied Tamarind OL",
                desc: "A festive delight evoking cinnamon, spices, tamarind and dried fruits in a sweet coffee base.",
                sku: "7903.40",
                imgPath: "/assets/images/2025/recipe_ol_cap3.png",
                props: [
                  { name: "Bitterness", value: 2 },
                  { name: "Acidity", value: 3 },
                  { name: "Roastiness", value: 2 },
                  { name: "Body", value: 2 },
                ],
              },
              recipt: [
                "Date Syrup: 10ml",
                "1x OL Cinnamon & Tamarind Coffee",
                "Milk 1.5%: 100ml",
                "Cream 35%: 500ml",
                "1x Cinnamon Powder & Cinnamon stick",
                "1x Chai Tea Bag",
              ],
            },
          },
        },
      ],
      vertuoPop: [
        {
          name: "Minted Coffee Mule",
          imagePath: "/assets/images/2025/recipe_vl_product_1.png",
          detail: {
            tag: "",
            title: "Minted Coffee Mule",
            desc: "Refresh yourself with our zesty Ginger Lime Iced Coffee, featuring muddled lime and honey, topped with ginger beer and a splash of shaken coffee, garnished with fresh mint.",
            time: "5 mins",
            difficulty: "Easy",
            productImgPath: "/assets/images/2025/recipe_vl_product_1.png",
            howToMake: {
              steps: [
                "In a Nespresso Mixology glass put half of fresh non treated lime (30 g) cut in 6 pieces, add 10ml of Honey.",
                "Muddle it. Put 3 Ice cubes.",
                "Pour 60ml of Ginger beer. Stir gently while lifting the lime pieces to mix them in.",
                "In a Nespresso shaker, extract 40ml of Coffee and add 2 ice cubes, close the lid, shake vigorously.",
                "Pour the ice coffee it gently in the glass over the mixture. Add a nice branch of non-treated mint leave on top.",
                "Optional: 30ml of Vodka",
              ],
            },
            whatYouWant: {
              machine: {
                name: "Vertuo Pop",
                desc: "Smallest Vertuo Machine",
                price: "HKD999",
                sku: "161568",
                imgPath: "/assets/images/2025/vertuo_pop_blue.png",
              },
              cap: {
                name: "Festive Collection Double Espresso",
                desc: "A deliciously round cup with cereal, ripe fruit and caramel notes, beautifully complemented by subtle woody undertones.",
                sku: "7079.40",
                imgPath: "/assets/images/2025/recipe_vl_cap1.png",
                props: [
                  { name: "Bitterness", value: 3 },
                  { name: "Acidity", value: 3 },
                  { name: "Roastiness", value: 3 },
                  { name: "Body", value: 3 },
                ],
              },
              recipt: [
                "1/2x Fresh non treated lime",
                "Honey: 10ml",
                "6x Nespresso ice cubes (30g)",
                "Ginger beer: 60ml",
              ],
            },
          },
        },
        {
          name: "Golden Hibiscus Latte",
          imagePath: "/assets/images/2025/recipe_vl_product_2.png",
          detail: {
            tag: "",
            title: "Golden Hibiscus Latte",
            desc: "Delight in our Sweet Almond & Hibiscus beverage, combining warm milk, honey, and aromatic edible flowers for a floral, cozy treat, with optional Dark Amarena cherries for an extra touch!",
            time: "5 mins",
            difficulty: "Easy",
            productImgPath: "/assets/images/2025/recipe_vl_product_2.png",
            howToMake: {
              steps: [
                "Heat up 100ml of milk 1.5% with the Barista Device (Hot milk mode).",
                "Into a Festive mug, put 10ml of honey and extract a 110ml OL Sweet Almond & Hibiscus (Double Click Recipe mode).",
                "Pour the hot milk into the mug.",
                "Sprinkle some dried edible Rose flowers or similars aromatic edible flowers.",
                "Optional: Add 2 Dark Amarena Cherries (on side)",
              ],
            },
            whatYouWant: {
              machine: {
                name: "Vertuo Pop",
                desc: "Smallest Vertuo Machine",
                price: "HKD999",
                sku: "161568",
                imgPath: "/assets/images/2025/vertuo_pop_blue.png",
              },
              cap: {
                name: "Festive collection Flavourd Almond & Hibiscus",
                desc: "A festive delight evoking almonds, hibiscus, red fruits and caramel in a sweet coffee base.",
                sku: "7078.40",
                imgPath: "/assets/images/2025/recipe_vl_cap2.png",
                props: [
                  { name: "Bitterness", value: 2 },
                  { name: "Acidity", value: 2 },
                  { name: "Roastiness", value: 2 },
                  { name: "Body", value: 2 },
                ],
              },
              recipt: [
                "Honey: 10ml",
                "1x OL Sweet Almond & Hibiscus",
                "Milk 1.5%: 100ml",
                "2x Amarena Cherries (Syrup)",
                "Edible Rose dried flowers: 1g",
              ],
            },
          },
        },
        {
          name: "Cinnamon Cloud Latte",
          imagePath: "/assets/images/2025/recipe_vl_product_3.png",
          detail: {
            tag: "",
            title: "Cinnamon Cloud Latte",
            desc: "Savor the festive Cinnamon & Candied Tamarind Coffee, featuring rich whipped cream, aromatic coffee, and a hint of cinnamon for a cozy treat!",
            time: "5 mins",
            difficulty: "Easy",
            productImgPath: "/assets/images/2025/recipe_vl_product_3.png",
            howToMake: {
              steps: [
                "Into a cream whipper siphon 0,5L, put 500ml of cream and one capsules* of whipper charger. Then shake it vigorously.",
                "Heat up 100ml of milk with the Barista Device (Hot milk mode).",
                "Into a Festive mug, put 10ml of date Syrup and extract a 110ml OL Cinnamon and Candied Tamarind Coffee.",
                "Pour the hot milk into the mug and add 60g of whipped cream on top.",
                "Add a cinnamon stick into the cream and sprinkle some cinnamon Powder.",
                "Optional: Infuse a bag of chai tea in 70 ml of hot water, cool it down, and add it to the siphon with the cream.",
              ],
            },
            whatYouWant: {
              machine: {
                name: "Vertuo Pop",
                desc: "Smallest Vertuo Machine",
                price: "HKD999",
                sku: "161568",
                imgPath: "/assets/images/2025/vertuo_pop_blue.png",
              },
              cap: {
                name: "Festive Collection Cinnamon and Candied Tamarind VL",
                desc: "A festive delight evoking cinnamon, spices, tamarind and dried fruits in a sweet coffee base.",
                sku: "7075.40",
                imgPath: "/assets/images/2025/recipe_vl_cap3.png",
                props: [
                  { name: "Bitterness", value: 2 },
                  { name: "Acidity", value: 2 },
                  { name: "Roastiness", value: 2 },
                  { name: "Body", value: 2 },
                ],
              },
              recipt: [
                "Date Syrup: 10ml",
                "1x OL Cinnamon & Tamarind Coffee",
                "Milk 1.5%: 100ml",
                "Cream 35%: 500ml",
                "1x Cinnamon Powder & Cinnamon stick",
                "1x Chai Tea Bag",
              ],
            },
          },
        },
      ],
    },
  },

  tnc: {
    title: "Nespresso eCom Vertuo Pop Redemption Promotion",
    desc: `<p>Redeem a set of <b>Selected 3-Sleeves Vertuo Coffee Capsules</b> and a <b>Touch Nomad Travel Mug</b> at redemption price of $1 upon purchasing a Vertuo Pop Coffee Machine at original price of HKD 1,088. Limited 200 sets available.</p>
    
    <h3>Terms and conditions apply</h3>

    <ol>
<li>Redeem a set of <b>Selected 3-Sleeves Vertuo Coffee Capsules</b> (including 10 x Barista Creations Roasted Hazelnut, 10 x Espresso Altissio, and 10 x Long Black Odacio) and a <b>Touch Nomad Travel Mug</b> at redemption price of $1 upon purchasing a Vertuo Pop Coffee Machine at original price of HKD 1,088.</li>
<li>The promotion is valid from 6 May 2024 until 16 Jun 2024 while stocks last, in Hong Kong and Macau only. Only 200 sets are available for redemption.</li>
<li>The promotion is available exclusively at Nespresso Online Boutique (www.nespresso.com/hk and mobile applications) and Customer Service Hotline (Hong Kong: 8101 1007, Macau 0800 846).</li>
<li>This promotion is not eligible for Boutique pickup service.</li>
<li>This promotion is not redeemable for cash, other products, or changes and cannot be used in conjunction with other promotional offers of Nespresso & Nespresso's trade partners.</li>
<li>In case of any disputes, Nespresso, a division of Nestlé Hong Kong Ltd. reserves the final right of decision and interpretation.</li>
<li>Each Member is entitled to enjoy this offer once per order only.</li>
</ol>
    `,
  },
};
